import { createNaturalMultiplicationTask, randInt, zeroOneExplanation } from "./sharedNaturalMultiplication";

function pickData() {
  const base = randInt(2, 99);
  const factor = Math.random() < 0.5 ? 0 : 1;
  const flip = Math.random() < 0.5;
  const a = flip ? factor : base;
  const b = flip ? base : factor;
  return { a, b, result: a * b };
}

const mod = createNaturalMultiplicationTask({
  type: "NaturalMulZeroOneTask",
  pickData,
  explain: zeroOneExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
